<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/klTq8C/tc-custom/9781429927161.jpg?1730581085196" alt="This image is the cover for the book Eifelheim"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eifelheim
      </h1>
      <p class="bookDescription body article font2">
        <b>“Carl Sagan meets Umberto Eco. . . . Bursting with pungent historical detail . . . this dense, provocative novel offers big rewards to patient readers.” —<i>Entertainment Weekly</i></b><br/><br/>The alien world of medieval Europe lives again, transformed by the physics of the future, by a winner of the Heinlein Award.<br/><br/>Over the centuries, one small town in Germany has disappeared and never been resettled. Tom, a historian, and his theoretical physicist girlfriend Sharon, become interested. By all logic, the town should have survived. What’s so special about Eifelheim?<br/><br/>Father Dietrich is the village priest of Eifelheim, in the year 1348, when the Black Death is gathering strength but is still not nearby. Dietrich is an educated man, and to his astonishment becomes the first contact person between humanity and an alien race from a distant star, when their ship crashes in the nearby forest.<br/><br/>It is a time of wonders, in the shadow of the plague. Tom and Sharon, and Father Deitrich have a strange destiny of tragedy and triumph in <i>Eifelheim</i>, the brilliant science fiction novel by Michael Flynn.<br/><br/>“Heartbreaking. . . . Flynn masterfully achieves an intricate panorama of medieval life, full of fascinatingly realized human and [alien] characters whose fates interconnect with poignant irony.” —<i>Publishers Weekly</i>, starred review<br/><br/>“Meticulously researched, intense, mesmerizing novel . . . for readers seeking thoughtful science fiction of the highest order.” —<i>Kirkus Reviews</i>, starred review<br/><br/>“<i>Eifelheim</i> may turn out to be the best science fiction novel this year.” —Orson Scott Card, Hugo Award–winning author of <i>Ender’s Game</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Flynn
      </h2>
      
      <p class="authorDescription body article"><B>Michael Flynn </B>lives in Easton, Pennsylvania. He is the winner of the Robert A. Heinlein award, and a Hugo Nominee for <I>Eifelheim</I>. He is the author of the Firestar series of novels, and is an <I>Analog</I> magazine alumnus whose fiction now appears regularly in all the major SF magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1f5e3a6